import { render, staticRenderFns } from "./ShareStudy.vue?vue&type=template&id=2ed0300d&scoped=true"
import script from "./ShareStudy.vue?vue&type=script&lang=js"
export * from "./ShareStudy.vue?vue&type=script&lang=js"
import style0 from "./ShareStudy.vue?vue&type=style&index=0&id=2ed0300d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed0300d",
  null
  
)

export default component.exports